/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import { Row , Col   , Button} from 'react-bootstrap';
import FieldGroup from '../FieldGroup.js';
import {AccountService} from '../../services';
import {Translation, AccountStore} from '../../store';
import Constants from '../../constants.js';
import Popup from '../popup/information_popup.js';
/*
 <Card body bg="danger" text="white">
 <b><h5>Failed Payment</h5>
 <small>Any user with access to a establishment admin system except the register and head should reactivate there account every so often as a backup process to prevent any unautherised access <a class="hyperlink" herf="#"  onClick={policyOpen}>see policy</a></small></b>
 <br/>
 </Card>
 <br/>
 <Card body bg="danger" text="white">
 <b><h5>Late Payment</h5>
 <small>Any user with access to a establishment admin system except the register and head should reactivate there account every so often as a backup process to prevent any unautherised access <a class="hyperlink" herf="#"  onClick={policyOpen}>see policy</a></small></b>
 <br/>
 </Card>
 <br/>
 <Card body bg="warning" text="white">
 <b><h5>Payment Due</h5>
 <small>Any user with access to a establishment admin system except the register and head should reactivate there account every so often as a backup process to prevent any unautherised access <a class="hyperlink" herf="#"  onClick={policyOpen}>see policy</a></small></b>
 <br/>
 </Card>
 */
export default class Establishment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countries:Translation.getCountriesList(),
            loaded:true
        };
    }

    save(){

    }

    sendEmail(){
        AccountService.requestRenew().then(function(){
            this.setState({show:true})
        }.bind(this))
    }

    sendEmail(){
        AccountService.sendEmail(this.state.name , this.state.email , this.state.message).then(function(){
            this.setState({
                show:true,
                name:'',
                email:'',
                message:'',
            })
        }.bind(this))
    }

    componentDidMount(){
        AccountService.getInformation();
    }

    componentWillMount(){

        AccountStore.on(Constants.GET_ACCOUNT , ()=>{
            this.setState({
                loaded:true
            });
        })
    }

    render() {

        return <div>
            <Popup show={this.state.show} onHide={()=>{this.setState({show:false})}} >
               <center> <h4>{Translation.get(12646 , 'Thank you')}</h4>
                <br/>
                {Translation.get(12647 , 'A member of our team will be touch as soon as possible')}</center>
            </Popup>

            <b><h5>{Translation.get(796 , 'Contact Us')}</h5></b>
                <Row>
                    <Col md={6}>
                        <FieldGroup value={this.state.name} onChange={(event)=>{ this.setState({name:event.target.value})}} label={Translation.get(14 , 'Name')} />
                    </Col>
                    <Col md={6}>
                        <FieldGroup value={this.state.email} onChange={(event)=>{ this.setState({email:event.target.value})}} label={Translation.get(9 , 'Email')} />
                    </Col>
                    <Col md={12}>
                        <FieldGroup value={this.state.message} onChange={(event)=>{ this.setState({message:event.target.value})}} style={{"resize":"none"}} as="textarea" rows="4" label={Translation.get(12319 , 'Message')} />
                    </Col>
                </Row>
            <Row>
                <Col md={12}>
                    <Button onClick={this.sendEmail.bind(this)} jclassName="float-right" >{Translation.get(254 , 'Send')}</Button>
                </Col>
            </Row>
        </div>;
    }

}